import Phaser from "phaser";
let replayButton
export default class WinScene extends Phaser.Scene {

    constructor() {
        super('win-scene')
    }

    preload() {
        this.load.image('background', 'images/bg_layer1.png')
        this.load.image('win-bg', 'images/win.png')
        this.load.image('replay-button', 'images/replay.png')
    }

    create(){
        this.add.image(240, 320, 'background')
        this.add.image(240, 280, 'win-bg').setScale(0.35)

        this.replayButton = this.add.image(240, 420, 'replay-button').setInteractive()

        // ketika di klik, scene akan berpindah ke BunnyJumpScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('bunny-jump-scene')
        }, this)
    }
}